import { createElement } from 'react';
import {
  IconAlignBoxCenterBottom,
  IconArrowBackUp,
  IconBackground,
  IconHeadphones,
  IconLabelFilled,
  IconMinimize,
  IconMovie,
  IconMusic,
  IconPlayerPlay,
  IconPlayerPlayFilled,
  IconSquare,
  IconSquareRounded,
  IconThumbUp,
  IconThumbUpFilled,
  IconWand
} from '@tabler/icons-react';
import { Theme } from '@/context/AppContext/AppContextTypes';
import { ReactComponent as ArrowUpRightSvg } from '@/assets/icons/cvent/ArrowUpRight.svg';
import { ReactComponent as IconAdjustmentsAltSvg } from '@/assets/icons/cvent/IconAdjustmentsAlt.svg';
import { ReactComponent as IconAlertCircleSvg } from '@/assets/icons/cvent/IconAlertCircle.svg';
import { ReactComponent as IconAlertTriangleSvg } from '@/assets/icons/cvent/IconAlertTriangle.svg';
import { ReactComponent as IconArrowBackUpSvg } from '@/assets/icons/cvent/IconArrowBackUp.svg';
import { ReactComponent as IconArrowBarRightSvg } from '@/assets/icons/cvent/IconArrowBarRight.svg';
import { ReactComponent as IconArrowBarToLeftSvg } from '@/assets/icons/cvent/IconArrowBarToLeft.svg';
import { ReactComponent as IconArrowDownSvg } from '@/assets/icons/cvent/IconArrowDown.svg';
import { ReactComponent as IconArrowRightSvg } from '@/assets/icons/cvent/IconArrowRight.svg';
import { ReactComponent as IconArrowForwardUpSvg } from '@/assets/icons/cvent/IconArrowForwardUp.svg';
import { ReactComponent as IconArrowLeftSvg } from '@/assets/icons/cvent/IconArrowLeft.svg';
import { ReactComponent as IconArrowUpSvg } from '@/assets/icons/cvent/IconArrowUp.svg';
import { ReactComponent as IconArrowsMoveSvg } from '@/assets/icons/cvent/IconArrowsMove.svg';
import { ReactComponent as IconArtboardSvg } from '@/assets/icons/cvent/IconArtboard.svg';
import { ReactComponent as IconBackgroundSvg } from '@/assets/icons/cvent/IconBackground.svg';
import { ReactComponent as IconBadgeCcSvg } from '@/assets/icons/cvent/IconBadgeCc.svg';
import { ReactComponent as IconBoltSvg } from '@/assets/icons/cvent/IconBolt.svg';
import { ReactComponent as IconBrandLinkedinSvg } from '@/assets/icons/cvent/IconBrandLinkedin.svg';
import { ReactComponent as IconBrandYoutubeSvg } from '@/assets/icons/cvent/IconBrandYoutube.svg';
import { ReactComponent as IconBulbSvg } from '@/assets/icons/cvent/IconBulb.svg';
import { ReactComponent as IconBulbFilledSvg } from '@/assets/icons/cvent/IconBulbFilled.svg';
import { ReactComponent as IconCalendarSvg } from '@/assets/icons/cvent/IconCalendar.svg';
import { ReactComponent as IconCheckSvg } from '@/assets/icons/cvent/IconCheck.svg';
import { ReactComponent as IconChevronDownSvg } from '@/assets/icons/cvent/IconChevronDown.svg';
import { ReactComponent as IconChevronLeftSvg } from '@/assets/icons/cvent/IconChevronLeft.svg';
import { ReactComponent as IconChevronRightSvg } from '@/assets/icons/cvent/IconChevronRight.svg';
import { ReactComponent as IconChevronUpSvg } from '@/assets/icons/cvent/IconChevronUp.svg';
import { ReactComponent as IconChevronsLeftSvg } from '@/assets/icons/cvent/IconChevronsLeft.svg';
import { ReactComponent as IconChevronsRightSvg } from '@/assets/icons/cvent/IconChevronsRight.svg';
import { ReactComponent as IconChevronsUpSvg } from '@/assets/icons/cvent/IconChevronsUp.svg';
import { ReactComponent as IconCircleCheckSvg } from '@/assets/icons/cvent/IconCircleCheck.svg';
import { ReactComponent as IconCircleCheckFilledSvg } from '@/assets/icons/cvent/IconCircleCheckFilled.svg';
import { ReactComponent as IconClockSvg } from '@/assets/icons/cvent/IconClock.svg';
import { ReactComponent as IconColorPickerSvg } from '@/assets/icons/cvent/IconColorPicker.svg';
import { ReactComponent as IconCopySvg } from '@/assets/icons/cvent/IconCopy.svg';
import { ReactComponent as IconCropSvg } from '@/assets/icons/cvent/IconCrop.svg';
import { ReactComponent as IconDotsSvg } from '@/assets/icons/cvent/IconDots.svg';
import { ReactComponent as IconDotsVerticalSvg } from '@/assets/icons/cvent/IconDotsVertical.svg';
import { ReactComponent as IconDownloadSvg } from '@/assets/icons/cvent/IconDownload.svg';
import { ReactComponent as IconEditSvg } from '@/assets/icons/cvent/IconEdit.svg';
import { ReactComponent as IconExclamationCircleSvg } from '@/assets/icons/cvent/IconExclamationCircle.svg';
import { ReactComponent as IconEyeSvg } from '@/assets/icons/cvent/IconEye.svg';
import { ReactComponent as IconEyeOffSvg } from '@/assets/icons/cvent/IconEyeOff.svg';
import { ReactComponent as IconInfoCircleSvg } from '@/assets/icons/cvent/IconInfoCircle.svg';
import { ReactComponent as IconLanguageSvg } from '@/assets/icons/cvent/IconLanguage.svg';
import { ReactComponent as IconLayoutGridSvg } from '@/assets/icons/cvent/IconLayoutGrid.svg';
import { ReactComponent as IconLinkSvg } from '@/assets/icons/cvent/IconLink.svg';
import { ReactComponent as IconListSvg } from '@/assets/icons/cvent/IconList.svg';
import { ReactComponent as IconListNumbersSvg } from '@/assets/icons/cvent/IconListNumbers.svg';
import { ReactComponent as IconLoader2Svg } from '@/assets/icons/cvent/IconLoader2.svg';
import { ReactComponent as IconLockSvg } from '@/assets/icons/cvent/IconLock.svg';
import { ReactComponent as IconMailSvg } from '@/assets/icons/cvent/IconMail.svg';
import { ReactComponent as IconMicrophone2Svg } from '@/assets/icons/cvent/IconMicrophone2.svg';
import { ReactComponent as IconMicrophoneOffSvg } from '@/assets/icons/cvent/IconMicrophoneOff.svg';
import { ReactComponent as IconMinusSvg } from '@/assets/icons/cvent/IconMinus.svg';
import { ReactComponent as IconMusicSvg } from '@/assets/icons/cvent/IconMusic.svg';
import { ReactComponent as IconPaletteSvg } from '@/assets/icons/cvent/IconPalette.svg';
import { ReactComponent as IconPauseSvg } from '@/assets/icons/cvent/IconPause.svg';
import { ReactComponent as IconPencilSvg } from '@/assets/icons/cvent/IconPencil.svg';
import { ReactComponent as IconPhotoSvg } from '@/assets/icons/cvent/IconPhoto.svg';
import { ReactComponent as IconPictureInPictureSvg } from '@/assets/icons/cvent/IconPictureInPicture.svg';
import { ReactComponent as IconPlaySvg } from '@/assets/icons/cvent/IconPlay.svg';
import { ReactComponent as IconPlayerPauseFilledSvg } from '@/assets/icons/cvent/IconPlayerPauseFilled.svg';
import { ReactComponent as IconPlayerPlayFilledSvg } from '@/assets/icons/cvent/IconPlayerPlayFilled.svg';
import { ReactComponent as IconPlusSvg } from '@/assets/icons/cvent/IconPlus.svg';
import { ReactComponent as IconRefreshSvg } from '@/assets/icons/cvent/IconRefresh.svg';
import { ReactComponent as IconRepeatSvg } from '@/assets/icons/cvent/IconRepeat.svg';
import { ReactComponent as IconRuler3Svg } from '@/assets/icons/cvent/IconRuler3.svg';
import { ReactComponent as IconScreenShareSvg } from '@/assets/icons/cvent/IconScreenShare.svg';
import { ReactComponent as IconSearchSvg } from '@/assets/icons/cvent/IconSearch.svg';
import { ReactComponent as IconSparklesSvg } from '@/assets/icons/cvent/IconSparkles.svg';
import { ReactComponent as IconSendSvg } from '@/assets/icons/cvent/IconSend.svg';
import { ReactComponent as IconSwitchHorizontalSvg } from '@/assets/icons/cvent/IconSwitchHorizontal.svg';
import { ReactComponent as IconSettingsSvg } from '@/assets/icons/cvent/IconSettings.svg';
import { ReactComponent as IconShare2Svg } from '@/assets/icons/cvent/IconShare2.svg';
import { ReactComponent as IconSquareSvg } from '@/assets/icons/cvent/IconSquare.svg';
import { ReactComponent as IconSquareRoundedSvg } from '@/assets/icons/cvent/IconSquareRounded.svg';
import { ReactComponent as IconStarSvg } from '@/assets/icons/cvent/IconStar.svg';
import { ReactComponent as IconStarFilledSvg } from '@/assets/icons/cvent/IconStarFilled.svg';
import { ReactComponent as IconTagSvg } from '@/assets/icons/cvent/IconTag.svg';
import { ReactComponent as IconTemplateSvg } from '@/assets/icons/cvent/IconTemplate.svg';
import { ReactComponent as IconThumbDownSvg } from '@/assets/icons/cvent/IconThumbDown.svg';
import { ReactComponent as IconThumbDownFilledSvg } from '@/assets/icons/cvent/IconThumbDownFilled.svg';
import { ReactComponent as IconThumbUpSvg } from '@/assets/icons/cvent/IconThumbUp.svg';
import { ReactComponent as IconThumbUpFilledSvg } from '@/assets/icons/cvent/IconThumbUpFilled.svg';
import { ReactComponent as IconTrashSvg } from '@/assets/icons/cvent/IconTrash.svg';
import { ReactComponent as IconUploadSvg } from '@/assets/icons/cvent/IconUpload.svg';
import { ReactComponent as IconVideoSvg } from '@/assets/icons/cvent/IconVideo.svg';
import { ReactComponent as IconVolumeSvg } from '@/assets/icons/cvent/IconVolume.svg';
import { ReactComponent as IconVolumeOffSvg } from '@/assets/icons/cvent/IconVolumeOff.svg';
import { ReactComponent as IconWandSvg } from '@/assets/icons/cvent/IconWand.svg';
import { ReactComponent as IconWorldSvg } from '@/assets/icons/cvent/IconWorld.svg';
import { ReactComponent as IconXSvg } from '@/assets/icons/cvent/IconX.svg';
import { ReactComponent as IconZoomInSvg } from '@/assets/icons/cvent/IconZoomIn.svg';
import { ReactComponent as IconZoomOutSvg } from '@/assets/icons/cvent/IconZoomOut.svg';
import { ReactComponent as IconCalendarEventSvg } from '@/assets/icons/cvent/IconCalendarEvent.svg';
import { ReactComponent as IconFontTypeSvg } from '@/assets/icons/cvent/IconFontType.svg';
import { ReactComponent as IconLockFilledSvg } from '@/assets/icons/cvent/IconLockFilled.svg';
import { ReactComponent as IconVideoClipSvg } from '@/assets/icons/cvent/IconVideoClip.svg';
import { ReactComponent as IconNoteSvg } from '@/assets/icons/cvent/IconNote.svg';
import { ReactComponent as IconStylesSvg } from '@/assets/icons/cvent/IconStyles.svg';
import { ReactComponent as IconStarSquareSvg } from '@/assets/icons/cvent/IconStarSquare.svg';
import { ReactComponent as IconContrastSvg } from '@/assets/icons/cvent/IconContrast.svg';
import { ReactComponent as IconRotateRightSvg } from '@/assets/icons/cvent/IconRotateRight.svg';
import { ReactComponent as IconRotateLeftSvg } from '@/assets/icons/cvent/IconRotateLeft.svg';
import { ReactComponent as IconMaximizeSvg } from '@/assets/icons/cvent/IconMaximize.svg';
import { ReactComponent as IconPaperTableSvg } from '@/assets/icons/cvent/IconPaperTable.svg';
import { ReactComponent as IconPlusCircleSvg } from '@/assets/icons/cvent/IconPlusCircle.svg';
import { ReactComponent as IconHomeSvg } from '@/assets/icons/cvent/IconHome.svg';
import { ReactComponent as IconShareSvg } from '@/assets/icons/cvent/IconShare.svg';
import { ReactComponent as IconXCircleSvg } from '@/assets/icons/cvent/IconXCircle.svg';
import { ReactComponent as IconArrangeLayersSvg } from '@/assets/icons/cvent/IconArrangeLayers.svg';
import { ReactComponent as IconPerimeterSeatingSvg } from '@/assets/icons/cvent/IconPerimeterSeating.svg';
import { ReactComponent as IconMinimizeSvg } from '@/assets/icons/cvent/IconMinimize.svg';
import { ReactComponent as IconComputerSvg } from '@/assets/icons/cvent/IconComputer.svg';
import { ReactComponent as IconTabletSvg } from '@/assets/icons/cvent/IconTablet.svg';
import { ReactComponent as IconExhibitorsSvg } from '@/assets/icons/cvent/IconExhibitors.svg';
import { ReactComponent as IconFireSvg } from '@/assets/icons/cvent/IconFire.svg';
import { ReactComponent as IconNoteFilledSvg } from '@/assets/icons/cvent/IconNoteFilled.svg';
import { ReactComponent as IconMailLetterSvg } from '@/assets/icons/cvent/IconMailLetter.svg';
import { ReactComponent as IconIdCardSvg } from '@/assets/icons/cvent/IconIdCard.svg';
import { ReactComponent as IconCompareSvg } from '@/assets/icons/cvent/IconCompare.svg';
import { ReactComponent as IconRestoreSvg } from '@/assets/icons/cvent/IconRestore.svg';
import { ReactComponent as IconHourglassSvg } from '@/assets/icons/cvent/IconHourglass.svg';
import { ReactComponent as IconReply1Svg } from '@/assets/icons/cvent/IconReply1.svg';
import { ReactComponent as IconVideoOffSvg } from '@/assets/icons/cvent/IconVideoOff.svg';
import { ReactComponent as IconSignatureSvg } from '@/assets/icons/cvent/IconSignature.svg';
import { ReactComponent as IconSessionSvg } from '@/assets/icons/cvent/IconSession.svg';
import { ReactComponent as IconLayoutGallerySvg } from '@/assets/icons/cvent/IconLayoutGallery.svg';
import { ReactComponent as IconCloudSvg } from '@/assets/icons/cvent/IconCloud.svg';
import { ReactComponent as IconSocialFeedSvg } from '@/assets/icons/cvent/IconSocialFeed.svg';
import { ReactComponent as IconVideoSquareSvg } from '@/assets/icons/cvent/IconVideoSquare.svg';
import { ReactComponent as IconFilterPhotoSvg } from '@/assets/icons/cvent/IconFilterPhoto.svg';
import { ReactComponent as IconRatingSvg } from '@/assets/icons/cvent/IconRating.svg';
import { ReactComponent as IconContentSvg } from '@/assets/icons/cvent/IconContent.svg';
import { ReactComponent as IconWebsiteRoundedSvg } from '@/assets/icons/cvent/IconWebsiteRounded.svg';
import { ReactComponent as IconWebsiteSharpSvg } from '@/assets/icons/cvent/IconWebsiteSharp.svg';
import { ReactComponent as IconNoneSvg } from '@/assets/icons/cvent/IconNone.svg';
import { ReactComponent as IconPollRoundedSvg } from '@/assets/icons/cvent/IconPollRounded.svg';
import { ReactComponent as IconPollSquareSvg } from '@/assets/icons/cvent/IconPollSquare.svg';
import { ReactComponent as IconNewsPaperSvg } from '@/assets/icons/cvent/IconNewsPaper.svg';
import { ReactComponent as IconSnapshotsSvg } from '@/assets/icons/cvent/IconSnapshots.svg';
import { ReactComponent as IconAiChatSvg } from '@/assets/icons/cvent/IconAiChat.svg';
import { ReactComponent as IconEraseSvg } from '@/assets/icons/cvent/IconErase.svg';
import { ReactComponent as IconOriginalRecordingSvg } from '@/assets/icons/cvent/IconOriginalRecording.svg';
import { ReactComponent as IconTextSvg } from '@/assets/icons/cvent/IconText.svg';
import { ReactComponent as IconArrangeSvg } from '@/assets/icons/cvent/IconArrange.svg';
import { ReactComponent as IconBoldSvg } from '@/assets/icons/cvent/IconBold.svg';
import { ReactComponent as IconXCircleFilledSvg } from '@/assets/icons/cvent/IconXCircleFilled.svg';
import { ReactComponent as IconArrowTransferVerticalSvg } from '@/assets/icons/cvent/IconArrowTransferVertical.svg';

/**
 * Cvent-branded icon components that map 1:1 onto an existing Tabler icon name
 * (e.g. the key `IconArrowLeft` replaces the Tabler icon of the same name).
 * Consumed by `Icon.tsx`, which merges this with `cventIconsAltIcons` and looks
 * up the merged map by icon name whenever `theme === 'cvent'`, so a Cvent SVG
 * is rendered instead of the default Tabler icon without changing call sites.
 */
export const cventIconsMap: Record<string, React.ComponentType<React.SVGProps<SVGSVGElement>>> = {
  IconArrowUpRight: ArrowUpRightSvg,
  IconAdjustmentsAlt: IconAdjustmentsAltSvg,
  IconAlertCircle: IconAlertCircleSvg,
  IconAlertTriangle: IconAlertTriangleSvg,
  IconArrowBackUp: IconArrowBackUpSvg,
  IconArrowBarRight: IconArrowBarRightSvg,
  IconArrowBarToLeft: IconArrowBarToLeftSvg,
  IconArrowDown: IconArrowDownSvg,
  IconArrowForwardUp: IconArrowForwardUpSvg,
  IconArrowLeft: IconArrowLeftSvg,
  IconArrowRight: IconArrowRightSvg,
  IconArrowUp: IconArrowUpSvg,
  IconArrowsMove: IconArrowsMoveSvg,
  IconArtboard: IconArtboardSvg,
  IconBackground: IconBackgroundSvg,
  IconBadgeCc: IconBadgeCcSvg,
  IconBolt: IconBoltSvg,
  IconBrandLinkedin: IconBrandLinkedinSvg,
  IconBrandYoutube: IconBrandYoutubeSvg,
  IconBulb: IconBulbSvg,
  IconBulbFilled: IconBulbFilledSvg,
  IconCalendar: IconCalendarSvg,
  IconCheck: IconCheckSvg,
  IconChevronDown: IconChevronDownSvg,
  IconChevronLeft: IconChevronLeftSvg,
  IconChevronRight: IconChevronRightSvg,
  IconChevronUp: IconChevronUpSvg,
  IconChevronsLeft: IconChevronsLeftSvg,
  IconChevronsRight: IconChevronsRightSvg,
  IconCircleCheck: IconCircleCheckSvg,
  IconCircleCheckFilled: IconCircleCheckFilledSvg,
  IconClock: IconClockSvg,
  IconColorPicker: IconColorPickerSvg,
  IconCopy: IconCopySvg,
  IconCrop: IconCropSvg,
  IconDots: IconDotsSvg,
  IconDotsVertical: IconDotsVerticalSvg,
  IconDownload: IconDownloadSvg,
  IconEdit: IconEditSvg,
  IconExclamationCircle: IconExclamationCircleSvg,
  IconEye: IconEyeSvg,
  IconEyeOff: IconEyeOffSvg,
  IconInfoCircle: IconInfoCircleSvg,
  IconLanguage: IconLanguageSvg,
  IconLayoutGrid: IconLayoutGridSvg,
  IconLink: IconLinkSvg,
  IconList: IconListSvg,
  IconListNumbers: IconListNumbersSvg,
  IconLoader2: IconLoader2Svg,
  IconLock: IconLockSvg,
  IconMail: IconMailSvg,
  IconMicrophone2: IconMicrophone2Svg,
  IconMicrophoneOff: IconMicrophoneOffSvg,
  IconMinus: IconMinusSvg,
  IconMusic: IconMusicSvg,
  IconPalette: IconPaletteSvg,
  IconPause: IconPauseSvg,
  IconPencil: IconPencilSvg,
  IconPhoto: IconPhotoSvg,
  IconPictureInPicture: IconPictureInPictureSvg,
  IconPlay: IconPlaySvg,
  IconPlayerPauseFilled: IconPlayerPauseFilledSvg,
  IconPlayerPlayFilled: IconPlayerPlayFilledSvg,
  IconPlus: IconPlusSvg,
  IconRefresh: IconRefreshSvg,
  IconRepeat: IconRepeatSvg,
  IconRuler3: IconRuler3Svg,
  IconScreenShare: IconScreenShareSvg,
  IconSearch: IconSearchSvg,
  IconSparkles: IconSparklesSvg,
  IconSend: IconSendSvg,
  IconSettings: IconSettingsSvg,
  IconShare2: IconShare2Svg,
  IconSquare: IconSquareSvg,
  IconSquareRounded: IconSquareRoundedSvg,
  IconStar: IconStarSvg,
  IconStarFilled: IconStarFilledSvg,
  IconSwitchHorizontal: IconSwitchHorizontalSvg,
  IconTag: IconTagSvg,
  IconTemplate: IconTemplateSvg,
  IconThumbDown: IconThumbDownSvg,
  IconThumbDownFilled: IconThumbDownFilledSvg,
  IconThumbUp: IconThumbUpSvg,
  IconThumbUpFilled: IconThumbUpFilledSvg,
  IconTrash: IconTrashSvg,
  IconUpload: IconUploadSvg,
  IconVideo: IconVideoSvg,
  IconVolume: IconVolumeSvg,
  IconVolumeOff: IconVolumeOffSvg,
  IconWand: IconWandSvg,
  IconWorld: IconWorldSvg,
  IconX: IconXSvg,
  IconZoomIn: IconZoomInSvg,
  IconZoomOut: IconZoomOutSvg,
  IconCalendarEvent: IconCalendarEventSvg,
  IconHome: IconHomeSvg,
  IconShare3: IconShareSvg,
  IconRestore: IconRestoreSvg,
  IconScript: IconNewsPaperSvg,
  IconLoader: IconLoader2Svg,
  IconPencilBolt: IconSnapshotsSvg,
  IconMessageBolt: IconAiChatSvg,
  IconTextSize: IconTextSvg,
  IconGripVertical: IconArrangeSvg,
  IconArrowsMaximize: IconMaximizeSvg,
  IconBold: IconBoldSvg,
  IconSquareRoundedXFilled: IconXCircleFilledSvg,
  IconCircleXFilled: IconXCircleFilledSvg,
  IconSwitchVertical: IconArrowTransferVerticalSvg,
  IconFileUpload: IconUploadSvg
};

/**
 * Cvent-branded icon components used as visual replacements for Tabler icons
 * that don't have a direct Cvent equivalent (key is the Tabler icon name being
 * replaced, value is the closest-matching Cvent SVG). Like `cventIconsMap`,
 * it's merged into a single lookup in `Icon.tsx` and only applied when
 * `theme === 'cvent'`. If an icon here stops being a good fit for future
 * reuse across components, move it into `customIconsOverrides` instead, where
 * overrides are scoped to specific, named use cases rather than icon names.
 */
export const cventIconsAltIcons: Record<string, React.ComponentType<React.SVGProps<SVGSVGElement>>> = {
  IconTypography: IconFontTypeSvg,
  IconCloudDownload: IconDownloadSvg,
  IconLockSquareRoundedFilled: IconLockFilledSvg,
  IconMovie: IconVideoClipSvg,
  IconCategory2: IconLayoutGridSvg,
  IconFileTextAi: IconNoteSvg,
  IconWindowMaximize: IconScreenShareSvg,
  IconScribble: IconStylesSvg,
  IconShadow: IconContrastSvg,
  IconCloudCheck: IconCloudSvg,
  IconHighlight: IconStarSquareSvg,
  IconCopyCheck: IconCopySvg,
  IconReplace: IconSwitchHorizontalSvg,
  IconArrowNarrowUp: IconArrowUpSvg,
  IconArrowNarrowDown: IconArrowDownSvg,
  IconArrowNarrowLeft: IconArrowLeftSvg,
  IconArrowNarrowRight: IconArrowRightSvg,
  IconRotateClockwise2: IconRotateRightSvg,
  IconRotate2: IconRotateLeftSvg,
  IconArrowRightSquare: IconChevronsRightSvg,
  IconArrowUpSquare: IconChevronsUpSvg,
  IconMaximize: IconMaximizeSvg,
  IconFileText: IconPaperTableSvg,
  IconFingerprint: IconMicrophone2Svg,
  IconStars: IconWandSvg,
  IconClockHour3: IconClockSvg,
  IconTexture: IconBackgroundSvg,
  IconLayoutGridAdd: IconPlusCircleSvg,
  IconFileDescription: IconPaperTableSvg,
  IconPlayerPlay: IconPlaySvg,
  IconRewindBackward5: IconChevronsLeftSvg,
  IconRewindForward5: IconChevronsRightSvg,
  IconZzz: IconMicrophoneOffSvg,
  IconHeadphones: IconVolumeSvg,
  IconWashDryShade: IconContrastSvg,
  IconCloudUpload: IconUploadSvg,
  IconArrowBarToUp: IconShare2Svg,
  IconRefreshDot: IconRefreshSvg,
  IconFileTypePdf: IconPaperTableSvg,
  IconArrowBarLeft: IconArrowBarToLeftSvg,
  IconEyeClosed: IconEyeOffSvg,
  IconLanguageOff: IconXCircleSvg,
  IconSquareRoundedX: IconXCircleSvg,
  IconBookmarkMinus: IconTrashSvg,
  IconLayoutBottombarExpand: IconMaximizeSvg,
  IconLayoutList: IconArrangeLayersSvg,
  IconAspectRatio: IconPerimeterSeatingSvg,
  IconCrop11: IconSquareSvg,
  IconLayoutBottombarCollapse: IconMinimizeSvg,
  IconCropPortrait: IconTabletSvg,
  IconCropLandscape: IconComputerSvg,
  IconPhotoVideo: IconExhibitorsSvg,
  IconMailFast: IconMailLetterSvg,
  IconArticleFilled: IconNoteFilledSvg,
  IconBoom: IconFireSvg,
  IconArticle: IconNoteSvg,
  IconUserScan: IconMaximizeSvg,
  IconLayoutSidebarRight: IconIdCardSvg,
  IconLayoutColumns: IconCompareSvg,
  IconHourglassHigh: IconHourglassSvg,
  IconMessageCircle2Filled: IconReply1Svg,
  IconCloudCancel: IconVideoOffSvg,
  IconColorSwatch: IconColorPickerSvg,
  IconPrompt: IconSignatureSvg,
  IconAtom: IconSessionSvg,
  IconRotateDot: IconRestoreSvg,
  IconLayoutDashboard: IconLayoutGallerySvg,
  IconPlayerSkipBack: IconChevronsLeftSvg,
  IconPlayerSkipForward: IconChevronsRightSvg,
  IconScissors: IconCompareSvg,
  IconBounceRight: IconFilterPhotoSvg,
  IconSection: IconPerimeterSeatingSvg,
  IconCursorText: IconRatingSvg,
  IconBlockquote: IconContentSvg,
  IconBorderCornerPill: IconWebsiteRoundedSvg,
  IconBorderCornerSquare: IconWebsiteSharpSvg,
  IconPill: IconLinkSvg,
  IconRectangle: IconMaximizeSvg,
  IconArrowBackUpDouble: IconChevronsLeftSvg,
  IconDeviceFloppy: IconFilterPhotoSvg,
  IconMessage2X: IconEraseSvg,
  IconLetterCase: () => createElement('div', null, 'Aa'),
  IconLetterCaseUpper: () => createElement('div', null, 'AA')
};

/**
 * Per-theme, per-use-case icon overrides, keyed by an arbitrary "slot" name
 * (e.g. `IconMenuRecording`) rather than a Tabler/Cvent icon name. Both theme
 * branches must define the same set of slot keys so a slot always resolves
 * regardless of theme. In `Icon.tsx` this is checked first, before the
 * Tabler/Cvent name-based lookup, keyed by `theme` (falling back to
 * `goldcast`, matching the app's default theme) and then by `name`; a hit
 * here always wins over `cventIconsMap`/`cventIconsAltIcons` or the raw
 * Tabler icon set.
 *
 * Unlike the maps above, values here mix Cvent SVG components and raw
 * `@tabler/icons-react` components, whose prop types aren't structurally
 * compatible with each other (e.g. `stroke: string` vs `stroke: string |
 * number`), so the value type is intentionally wider than
 * `React.SVGProps<SVGSVGElement>`.
 */
const goldcastIconOverrides = {
  IconOriginalRecording: IconOriginalRecordingSvg,
  IconMenuRecording: IconMovie,
  IconMenuClips: IconPlayerPlay,
  IconMenuClipsFilled: IconPlayerPlayFilled,
  IconMenuSocial: IconThumbUp,
  IconMenuSocialFilled: IconThumbUpFilled,
  IconCustomizerCaptions: IconAlignBoxCenterBottom,
  IconCustomizerVideo: IconMovie,
  IconCustomizerAudio: IconHeadphones,
  IconCustomizerMusic: IconMusic,
  IconCustomizerAiEdits: IconWand,
  IconTransitionDrop: IconMinimize,
  IconTransparent: IconBackground,
  IconSpeakerLabelRounded: IconSquareRounded,
  IconSpeakerLabelSquare: IconSquare,
  IconOptimizeArrowBack: IconArrowBackUp,
  IconCuePointHead: IconLabelFilled
} satisfies Record<string, React.ComponentType<any>>;

/**
 * Slot names defined by `customIconsOverrides`, derived from the `goldcast`
 * branch. Typing the `cvent` branch as `Record<CustomIconSlotName, ...>`
 * below enforces the "both branches define the same set of slot keys"
 * invariant at compile time instead of only in the comment.
 */
export type CustomIconSlotName = keyof typeof goldcastIconOverrides;

export const customIconsOverrides: Record<Theme, Record<CustomIconSlotName, React.ComponentType<any>>> = {
  cvent: {
    IconOriginalRecording: IconOriginalRecordingSvg,
    IconMenuRecording: IconVideoSvg,
    IconMenuClips: IconVideoClipSvg,
    IconMenuClipsFilled: IconVideoClipSvg,
    IconMenuSocial: IconSocialFeedSvg,
    IconMenuSocialFilled: IconSocialFeedSvg,
    IconCustomizerCaptions: IconBadgeCcSvg,
    IconCustomizerVideo: IconVideoSquareSvg,
    IconCustomizerAudio: IconVolumeSvg,
    IconCustomizerMusic: IconVolumeSvg,
    IconCustomizerAiEdits: IconSparklesSvg,
    IconTransitionDrop: IconArrowDownSvg,
    IconTransparent: IconNoneSvg,
    IconSpeakerLabelRounded: IconPollRoundedSvg,
    IconSpeakerLabelSquare: IconPollSquareSvg,
    IconOptimizeArrowBack: IconChevronLeftSvg,
    IconCuePointHead: IconPlayerPauseFilledSvg
  },
  goldcast: goldcastIconOverrides
};
